function GetDetailsLocal() {
  return {
    projects: [
      {
        project: {
          id: "redfall",
          details: {
            name: "Redfall",
            genre: "First Person Shooter",
            shipInfo: "PC/Xbox Series, May 2023",
            myRole: "Gameplay Programmer",
            tools: "Unreal Engine (Native C++)",
            about:
              "Redfall is an open-world, co-op FPS from Arkane Austin, the award-winning team behind Prey and Dishonored. Continuing Arkane's legacy of carefully crafted worlds and immersive sims, Redfall brings the studio's signature gameplay to this story-driven action shooter.",
            contributions: [
              {
                blurb:
                  "Wrote native C++ components/systems in Unreal Engine for environmental hazards and player powers for client/server use. Worked directly with designers to fine-tune system needs and solve issues with interactions across systems. Environmental hazards include explosive barrels, electrical boxes, alarms, and area-of-effect damage zones for fire and death mist. Player powers utilize modified versions of similar systems for explosives and electrical damage.",
              },
              {
                blurb:
                  "Implemented damage instigation system used for tracking and providing originator of damage for other system use (example: notifying progression system when the player destroys a hazard that defeats nearby enemies).",
              },
            ],
            videoUrl: "https://www.youtube.com/embed/cR8GVePOdpY?si=OAUZmM2QqtcgP0uD",
          },
        },
      },
      {
        project: {
          id: "rune",
          details: {
            name: "Rune 2",
            genre: "3D Open-World Action RPG",
            shipInfo: "PC; 2019",
            myRole: "UI/Gameplay Programmer",
            tools: "Unreal Engine (UMG, Blueprints)",
            about:
              "Rune 2 is a sandbox, open-world RPG set in a dangerous Norse universe during the end of days. A highly anticipated follow-up to Rune Classic, the team's hit action-adventure game, Rune places players in the middle of an epic battle where gods, beasts, and the last remaining humans struggle to survive. By pledging allegiance to one of the Norse gods, players gain favor and special abilities to aid them as they raid enemy villages, fight the undead in brutal melee combat, sail to new lands, and craft powerful weapons to complete the goals of their god and conclude Ragnarok.",
            contributions: [
              {
                blurb:
                  "Designed UX and Implemented UI. Worked directly with artists to design proper user experience, visual interface ideas, and flow. Implemented the majority of UI with provided artwork using Unreal Blueprints and widget editor. Includes UI for all menus, in-game HUD, multiplayer, and popups/toast/prompts.",
              },
              {
                blurb:
                  "Updated and extended existing gameplay systems including inventory and world/object interactions.",
              },
              {
                blurb: "Implemented Team Deathmatch mode using Unreal Engine 4 Blueprints.",
              },
            ],
            videoUrl: "https://www.youtube.com/embed/iBideuSAFYc?si=eSFcliwHj3Fx8hMg",
          },
        },
      },
      {
        project: {
          id: "sb",
          details: {
            name: "Survived By",
            genre: "2D Online Bullet-Hell Roguelite",
            shipInfo: "PC; 2018",
            myRole: "Backend/Gameplay Programmer",
            tools: "Unity 3D (C#), ASP.NET, Python",
            about:
              "Survived By is a free to play retro-style fantasy survival MMO in which up to 100 players fight side-by-side in a bullet hell-style battle where permadeath is just the beginning. Mankind has been pushed to the end of extinction by an otherworldly corruption, but a few stalwart folk stand up and fight back. Create a character, grab your weapons, and face off against the encroaching darkness.",
            contributions: [
              {
                blurb:
                  "Implemented requested gameplay mechanics and game functionality. Examples include a timed teleport back to the tower (similar to World of Warcraft's hearthstone item) and server auto-selection based on region and player preferences.",
              },
              {
                blurb:
                  "Developed game code in a REST-based server/client cloud architecture using C# and SQL.",
              },
              {
                blurb:
                  "Implemented technical 'behind-the-scenes' systems such as automating player logon experience to “match-make” a player into the correct server based on region information and server availability.",
              },
              {
                blurb:
                  "Added extended features into the game's support tools. Support tools were written as a web-based dashboard for game/server maintenance and player support to be used by internal staff.",
              },
            ],
            videoUrl: "https://www.youtube.com/embed/e9gI7312OTE?si=4fdJNcm4DGzm1t2x",
          },
        },
      },
      {
        project: {
          id: "swc",
          details: {
            name: "Super Wall Crash",
            genre: "3D Procedural Infinite Runner",
            shipInfo: "iOS/Android; 2016",
            myRole: "Lead Programmer/Designer",
            tools: "Unity 3D (C#), Qubicle, Blender, Photoshop",
            about:
              "Super Wall Crash is a procedurally generated infinite runner shipped for Apple iOS and Google Android devices. The gameplay resembles Temple Run with an open world feel, along with a voxel-based art style reminiscent of Minecraft.",
            contributions: [
              {
                blurb:
                  "Wrote all aspects of gameplay code. This includes the complete procedural generation logic, dynamic object loading via runtime scripts, integration with third-party assets, and common core systems such as game state management and menu systems.",
              },
              {
                blurb:
                  "Designed all gameplay including core gameplay loop, level and character designs, and UI designs. Also tested and continually tweaked design values related to procedural generation randomization.",
              },
              {
                blurb:
                  "Created game art utilizing Qubicle Constructor to develop 3D assets, Blender to animate characters, and Photoshop for UI elements.",
              },
              {
                blurb:
                  "Self promoted game at public events. Hosted a public table at the Midwest Gaming Classic and presented voxel art development pipeline at the Madison Indies weekend meetup and at the Twin Cities Code Camp.",
              },
            ],
            videoUrl: "https://www.youtube.com/embed/gFNbTfsAl5Y?si=FDQirULf4aDi2LBh",
          },
        },
      },
      {
        project: {
          id: "tat",
          details: {
            name: "There Are 200",
            genre: "2D Twin-Stick Shooter",
            shipInfo: "N/A (Prototype)",
            myRole: "Lead Programmer/Designer",
            tools: "Unity 3D (C#), Photoshop",
            about:
              "There Are 200 is an abstract twin-stick shooter with procedurally picked rules in rounds of 200 enemies. Gameplay is similar to other top down twin-stick shooters such as Geometry Wars and features a simplistic abstract art style, various weapon types, and unique enemies.",
            contributions: [
              {
                blurb:
                  "Wrote reusable systems-focused code. I designed and developed each gameplay element as a system that would affect other systems. For example, weapon enhancements can be stacked to create differing gameplay scenarios (ex: explosive rounds can be stacked with ricocheting rounds to create bullets that bounce off walls and explode on contact).",
              },
              {
                blurb:
                  "Implement pre-made Unity assets to help future development and extend behind the scenes functionality. This includes assets not immediately noticeable to the player but assist in quickly bringing the prototype to life. Assets include InControl for controller input, and ProCamera2D for camera movement logic.",
              },
              {
                blurb:
                  "Designed progression systems including randomly generated skill trees for players to progress through.",
              },
              {
                blurb:
                  "Iterate over gameplay to refine game feel. This includes tweaking 'game feel' values such as screen shake amounts, weapon fire rates, enemy balancing, and other values that make second to second gameplay feel satisfying.",
              },
            ],
            videoUrl: "https://www.youtube.com/embed/UvKciv0KavE?si=SsrjMI4I46P-gLsj",
          },
        },
      },
      {
        project: {
          id: "jams",
          details: {
            name: "Game Jams & Prototypes",
            genre: "Various",
            myRole: "Lead Programmer/Designer",
            tools: "Unity 3D (C#), Photoshop, Blender",
            about:
              "I've participated and completed various game jams and additional prototypes listed below. They include Well Wishes (2D Cozy Puzzle), Night Light (2D Horror), Llama Llama (2D Local Multiplayer), and Knock (3D Horror Puzzle). These projects were made using Unity, C#, Photoshop, and Blender.",
            contributions: [
              {
                blurb:
                  "Developed all gameplay and core systems for each project. Each project was completed in a short time frame (1-30 days) and required quick iteration and problem solving to deliver a complete experience.",
              },
              {
                blurb:
                  "Created art and audio assets for each project. This includes 2D art, 3D models, animations, and sound effects.",
              },
            ],
            videoList: [
              {
                videoUrl: "https://www.youtube.com/embed/6SxMhuE8ssw?si=z5wnSYaOwC6d6xu7",
              },
              {
                videoUrl: "https://www.youtube.com/embed/StZg2cr9icY?si=tilcNWMX9dlqmufD",
              },
              {
                videoUrl: "https://www.youtube.com/embed/wMUsPpDVKIE?si=e8FanHWEc7l3Hw1x",
              },
              {
                videoUrl:
                  "https://www.youtube.com/embed/jmYK7LwHDbw?si=LuZ-poX-WqfftM0b&amp;start=35",
              },
            ],
          },
        },
      },
    ],
  };
}

export default GetDetailsLocal;
